import { VISIT_CRAWLER_APP } from './constants/policies'

export default {
  name: 'Crawler Setting',
  description: 'The setting of rhitics crawler.',
  accessors: ['crawler'],
  ns: 'CrawlerNS',
  shortName: 'Crawler',
  icon: 'fas fa-spider',
  policy: VISIT_CRAWLER_APP,
  document: 'https://docs.google.com/document/d/1-jYdnUFLJIpgepncG49MWUBKnLpgq0YYYuVgQxukjDU/edit?usp=sharing',
  isMoveToNewSite: false
}
